/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Trial_ActivateInputs */

const en_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Account`)
};

const fr_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le compte`)
};

const de_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto aktivieren`)
};

const it_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva account`)
};

const ru_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать аккаунт`)
};

const es_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar cuenta`)
};

const zh_cn2_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活账户`)
};

const ja_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを有効化`)
};

const hi_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता सक्रिय करें`)
};

const pt_pt2_subtitle_export_trial_activate = /** @type {(inputs: Subtitle_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar conta`)
};

/**
* | output |
* | --- |
* | "Activate Account" |
*
* @param {Subtitle_Export_Trial_ActivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_trial_activate = /** @type {((inputs?: Subtitle_Export_Trial_ActivateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Trial_ActivateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_trial_activate(inputs)
	if (locale === "de") return de_subtitle_export_trial_activate(inputs)
	if (locale === "it") return it_subtitle_export_trial_activate(inputs)
	if (locale === "ru") return ru_subtitle_export_trial_activate(inputs)
	if (locale === "es") return es_subtitle_export_trial_activate(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_trial_activate(inputs)
	if (locale === "ja") return ja_subtitle_export_trial_activate(inputs)
	if (locale === "hi") return hi_subtitle_export_trial_activate(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_trial_activate(inputs)
	return en_subtitle_export_trial_activate(inputs)
});